var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
// '#components' is imported by direct path: its barrel would close the hooks <-> components cycle (see CLAUDE.md).
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { useModal } from '@lucidlink/uicore';
import { DeploymentInProgressModal } from '#components/modals/DeploymentInProgressModal';
import { MODAL_IDS } from '#constants';
import { useLucidSdk } from '#context';
import { provisionStatusQueryFactory } from '#query-hooks';
export const useDeploymentGuard = () => {
    _react_refresh_temp_1();
    const queryClient = useQueryClient();
    const { lucidSdk } = useLucidSdk();
    const { closeModal, openModal } = useModal({
        modalId: MODAL_IDS.DeploymentInProgress,
        closeOnNavigate: false,
        closeOnUnmount: false,
    });
    const guard = useCallback(async (run, options) => {
        try {
            const status = await queryClient.fetchQuery({
                ...provisionStatusQueryFactory(lucidSdk, options.workspaceId),
                // Single point-in-time check: don't cache, force the
                // request, and fail-open immediately on error (a deploy can
                // run for a long time, so retrying/polling is pointless)
                networkMode: 'always',
                gcTime: 0,
                retry: false,
            });
            if (!status.filespaceProvisionEnabled) {
                openModal({
                    content: (_jsx(DeploymentInProgressModal, { closeModal: closeModal })),
                });
                return;
            }
        }
        catch {
        }
        run();
    }, [queryClient, lucidSdk, openModal, closeModal]);
    return { guard };
};
_react_refresh_temp_1(useDeploymentGuard, "FtYv1LVTGb09LM4qzEhjcg9tp5Y=", false, () => [useQueryClient, useLucidSdk, useModal]);
